import { LineChart } from 'lucide-react';

/** Lucide icon for Investments feature branding (sidebar nav, empty states). */
export const INVESTMENTS_FEATURE_ICON = LineChart;
